import React from 'react';
import tw from 'twin.macro';
import Layout from './Layout';
import PageHeader from './PageHeader';
import PostsGrid from './PostsGrid';
import SEO from './SEO';
import FilterProvider from '../utils/hooks/use-filter';

const Main = tw.main`relative w-full mx-auto p-5 lg:px-20 2xl:max-w-8xl text-white`;

const CategoryPageLayout = ({ title, description, seoDescription, slug, posts }) => (
  <Layout>
    <SEO title={title} description={seoDescription} slug={slug} />
    <Main>
      <PageHeader title={title} description={description} />
      <FilterProvider posts={posts}>
        <PostsGrid />
      </FilterProvider>
    </Main>
  </Layout>
);

export default CategoryPageLayout;
